import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["enabled"],
    _excluded2 = ["children"];
import * as React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useModifiedProps, useChart, useHighcharts } from 'react-jsx-highcharts';
import NavigatorXAxis from './NavigatorXAxis';

var Navigator = function Navigator(_ref) {
  var _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var props = _objectSpread({
    enabled: enabled
  }, restProps);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      rendered = _useState2[0],
      setRendered = _useState2[1];

  var chart = useChart();
  var Highcharts = useHighcharts();
  useEffect(function () {
    var children = props.children,
        rest = _objectWithoutProperties(props, _excluded2); // Workaround from http://jsfiddle.net/x40me94t/2/


    var chartObj = chart.object;
    chartObj.options.navigator.enabled = true; // Initialise Navigator https://github.com/highcharts/highcharts/blob/dd730ab/js/parts/Navigator.js#L1837-L1844

    Highcharts.fireEvent(chartObj, 'beforeRender');
    updateNavigator(rest, chart);
    setRendered(true);
    return function () {
      try {
        updateNavigator({
          enabled: false
        }, chart);
      } catch (_unused) {// ignore as chart might have been already unmounted
      }
    };
  }, []);
  var modifiedProps = useModifiedProps(props);
  useEffect(function () {
    if (modifiedProps !== false) {
      updateNavigator(modifiedProps, chart);
    }
  });
  var children = props.children;
  if (!children || !rendered) return null;
  return /*#__PURE__*/React.createElement(NavigatorXAxis, null, children);
};

var updateNavigator = function updateNavigator(config, chart) {
  chart.update({
    navigator: config
  }, true);
};

export default Navigator;